import LoginAsAdmin from './LoginAsAdmin';

export default LoginAsAdmin;
